
import { useEffect, useState, type FormEvent } from "react"
import { Box, Container, ThemeProvider, Typography } from "@mui/material"
import PaymentHeader from "../components/PaymentHeader"
import PaymentFooter from "../components/PaymentFooter"
import CardDetails from "../components/CardDetails"
import CardPayment from "../components/CardPayment"
import PaymentSuccess from "../components/PaymentSuccess"
import CardError from "../components/CardError"
import type { ClienteInfo, CardFormData, PaymentStatus, PaymentError } from "../types/payment"
import { garanttiTheme } from "../theme/garantti-theme"
import { useParams } from "react-router-dom"

const PaymentForm = () => {
  const [paymentStatus, setPaymentStatus] = useState<PaymentStatus>("idle")
  const [paymentError, setPaymentError] = useState<PaymentError | null>(null)
  const [lastFourDigits, setLastFourDigits] = useState<string>("")
  const { id } = useParams<{ id: string }>();

  // Dados do cliente e imóvel

useEffect(() => {
  const fetchClienteInfo = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API}installment-credit-card/details/${id}`);
      if (!response.ok) {
        throw new Error("Erro ao buscar os detalhes do cliente.");
      }
      const data = await response.json();

      const clienteInfo: ClienteInfo = {
        nome: data.name,
        cpf: data.document,
        imovel: {
          endereco: data.addressStreet+", " + data.addressNumber + ", " + data.addressComplement + ", " + data.addressCity + ", " + data.addressState,
          cep: data.addressZipcode,
        },
        imobiliaria: data.clientName,
        valores: {
          garantiaLocaticia: Number(data.rentAmount),
          total: Number(data.amount),
        },
      }

      setClienteInfo(clienteInfo);
    } catch (error) {
      console.error("Erro ao buscar os detalhes do cliente:", error);
    }
  };

  fetchClienteInfo();
}, []);

const [clienteInfo, setClienteInfo] = useState<ClienteInfo | null>(null);

  // const clienteInfo: ClienteInfo = {
  //   nome: "Roberto Wagner de Oliveira",
  //   cpf: "***.***.771-34",
  //   imovel: {
  //     endereco: "Alameda dos ..., Lagoa Santa, MG",
  //     cep: "33236-344",
  //   },
  //   imobiliaria: "START EMPREENDIMENTOS IMOBILIARIOS LTDA",
  //   valores: {
  //     garantiaLocaticia: 10.0,
  //     total: 10.0,
  //   },
  // }

  const handleSubmit = (e: FormEvent, cardData: CardFormData) => {
    e.preventDefault()
    setPaymentStatus("processing")
    cardData.cardNumber = cardData.cardNumber.replace(/\s/g, "") // Remove espaços do número do cartão
    console.log(cardData)
    // Aqui você pode integrar com a API de pagamento do PJBank ou outro serviço
    fetch(`${process.env.REACT_APP_BASE_API}installment-credit-card/process/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cardData),
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Erro ao processar o pagamento.");
        }
        setPaymentStatus("success");
      })
      .catch((error) => {
        setPaymentStatus("error");
        setPaymentError({
          code: "payment_failed",
          message: error.message || "Ocorreu um erro inesperado ao processar o pagamento.",
        });
      });

    // Salvar os últimos 4 dígitos do cartão para exibir na mensagem de erro
    const lastDigits = cardData.cardNumber.replace(/\s/g, "").slice(-4)
    setLastFourDigits(lastDigits)

    // Simulação de processamento com chance de erro
    // Para fins de demonstração, vamos simular um erro se o CVV for "123"
    setTimeout(() => {
      if (cardData.cvv === "000") {
        setPaymentStatus("error")
        setPaymentError({
          code: "payment_failed",
          message: `Não foi possível processar o pagamento com o cartão terminado em ${lastDigits}.`,
        })
      } else {
        setPaymentStatus("success")
      }
    }, 1500)
  }

  const handleTryAgain = () => {
    setPaymentStatus("idle")
    setPaymentError(null)
  }

  return (
    <ThemeProvider theme={garanttiTheme}>
      <PaymentHeader />

      {paymentStatus === "success" ? (
        <PaymentSuccess />
      ) : (
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Typography variant="h5" fontWeight="medium">
              Pagamento de Garantia Locatícia
            </Typography>
          </Box>

          {paymentStatus === "error" && paymentError && (
            <CardError errorMessage={paymentError.message} onTryAgain={handleTryAgain} />
          )}

          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 3 }}>
            {clienteInfo && <CardDetails clienteInfo={clienteInfo} />}

            {paymentStatus !== "error" && clienteInfo && (
              <CardPayment
                id={id!}
                totalValue={clienteInfo?.valores?.total ?? 0}
                onSubmit={handleSubmit}
                isProcessing={paymentStatus === "processing"}
                clientName={clienteInfo?.nome ?? ""}
              />
            )}
          </Box>
        </Container>
      )}

      <PaymentFooter />
    </ThemeProvider>
  )
}

export default PaymentForm

